export const apiRoutes = {
  getRolesDetails: () => '/roles',
};
